<template>
  <section v-if="isBlackFridayActive && promoBundlesOnCart">
    <div v-if="showAddOns" class="add-ons" data-testid="add-ons-bf">
      <div class="add-ons__content">
        <div class="add-ons__title">Add-ons</div>
        <div class="add-ons__items">
          <AddOnsListCertifications v-if="!(promoBundleOneOnCart || promoBundleTwoOnCart)" />
          <AddOnsSkillDiveItems v-if="promoBundleTwoOnCart || promoFundamentalsBundleOnCart" />
        </div>
      </div>
    </div>
  </section>
  <section v-else>
    <div class="add-ons" data-testid="add-ons-regular">
      <div class="add-ons__content">
        <div class="add-ons__title">Add-ons</div>
        <div class="add-ons__items">
          <AddOnsListCertifications
            :bundleCertificationSelected="
              this.bundleCertificationSelected && this.bundleCertificationSelected.voucher
            "
          />
          <AddOnsSkillDiveItems v-if="showSkillDiveAddOns" />
          <AddOnsListLVTItems />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import { updateCart, promoProductBundleUtils } from '@/helpers/mixins'
import AddOnsListCertifications from '@/components/cart/add-ons/AddOnsListCertifications.vue'
import AddOnsSkillDiveItems from '@/components/cart/add-ons/AddOnsSkillDiveItems.vue'
import AddOnsListLVTItems from '@/components/cart/add-ons/AddOnsListLVTItems.vue'
import CONSTANTS from '@/constants'

export default {
  name: 'AddOns',
  mixins: [updateCart, promoProductBundleUtils],
  components: {
    AddOnsListCertifications,
    AddOnsSkillDiveItems,
    AddOnsListLVTItems,
  },
  props: {
    bundleCertificationSelected: {
      type: Object,
      required: false,
      default: null,
    },
  },
  computed: {
    ...mapGetters({
      shoppingCart: 'shoppingCart/getShoppingCart',
      isBlackFridayActive: 'featureFlags/isBlackFridayActive',
      selectedPlan: 'shoppingCart/selectedPlan',
    }),
    showAddOns() {
      if (this.promoBundleOneOnCart) return false
      if (this.promoBundleTwoOnCart && !this.showSkillDiveAddOns) return false
      if (this.promoBundleTwoOnCart) return true
      if (this.promoFundamentalsBundleOnCart) return true
      if (this.promoFundamentalsBundleOnCart && !this.showSkillDiveAddOns) return true
      if (!this.showSkillDiveAddOns) return true
      return true
    },
    showSkillDiveAddOns() {
      const plan = this.shoppingCart.find(
        item => item.merchant_id === CONSTANTS.PLANS.SKILL_DIVE_ANNUAL
      )
      if (this.selectedPlan?.merchant_id === CONSTANTS.PLANS.PREMIUM_PLUS) {
        return false
      }
      if (!plan) return true
      return plan && plan.selectedAsAddOns
    },
  },
}
</script>

<style lang="scss" scoped>
.add-ons {
  &__content {
    margin: 20px 0;
    text-align: left;
  }
  &__title {
    font-weight: 700;
    font-size: rem(20px);
    line-height: 26px;
    margin-bottom: 10px;
  }
  &__items {
    display: flex;
    flex-flow: column;
    gap: 10px;
  }
}
</style>
